export enum Role {
  OWNER = 'Owner',
  DEPUTY = 'Deputy',
  AUTHOR = 'Author',
  MODERATOR = 'Moderator',
}
